import { render, staticRenderFns } from "./ItemsPerPage.vue?vue&type=template&id=3ce921ab&lang=pug&"
import script from "./ItemsPerPage.vue?vue&type=script&lang=js&"
export * from "./ItemsPerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce921ab')) {
      api.createRecord('3ce921ab', component.options)
    } else {
      api.reload('3ce921ab', component.options)
    }
    module.hot.accept("./ItemsPerPage.vue?vue&type=template&id=3ce921ab&lang=pug&", function () {
      api.rerender('3ce921ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/pagination/ItemsPerPage.vue"
export default component.exports